'use strict';

import { NgModule }             from '@angular/core';
import { FormsModule }          from '@angular/forms';

import { CodeEditorComponent }  from './component';

@NgModule({
  imports     : [
    FormsModule
  ],
  declarations: [CodeEditorComponent],
  exports     : [CodeEditorComponent]
})
export class LKCodeEditor {

}
